import React from 'react';
import PageWrapper from '../components/layout/PageWrapper';
import AmendBooking from '../containers/bookings/AmendBooking';


const AmendBookingPage = () => {
    return (
        <PageWrapper>
            <AmendBooking />
        </PageWrapper>
    );
};

export default AmendBookingPage;
